module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-lista"
  }, [_vm._m(0), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "curso-item"
    }, [_c('img', {
      staticClass: "curso-imagen",
      attrs: {
        "src": o.imagen,
        "alt": "Curso imagen"
      }
    }), _c('div', {
      staticClass: "curso-detalles"
    }, [_c('div', {
      staticClass: "curso-header"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("truncateText")(o.titulo, 20)))]), (o.descripcion) ? _c('div', {
      staticClass: "descripcion"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("truncateText")(o.descripcion, 30)))])]) : _vm._e()]), _c('div', {
      staticClass: "curso-info"
    }, [_c('span', [_vm._v("Duración: " + _vm._s(o.DuracionTotal))]), _c('span', [_vm._v("Clases: " + _vm._s(o.NumeroClases))]), _c('span', [_vm._v("Progreso: " + _vm._s(o.progreso) + "%")])])]), _c('div', {
      staticClass: "curso-botones"
    }, [(o.progreso === 0) ? _c('button', {
      staticClass: "button is-primary",
      on: {
        "click": function($event) {
          return _vm.iniciarCurso(o.id)
        }
      }
    }, [_vm._v("Iniciar curso")]) : _vm._e(), (o.progreso > 0 && o.progreso < 100) ? _c('button', {
      staticClass: "button is-info",
      on: {
        "click": function($event) {
          return _vm.iniciarCurso(o.id)
        }
      }
    }, [_vm._v("Continuar")]) : _vm._e(), (o.progreso === 100) ? _c('button', {
      staticClass: "button is-warning",
      on: {
        "click": function($event) {
          return _vm.iniciarCurso(o.id)
        }
      }
    }, [_vm._v("Volver a iniciar")]) : _vm._e()])])
  }) : _vm._e()], 2), (!_vm.isLoading && _vm.lista.length === 0) ? _c('div', [_vm._m(1)]) : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_vm._m(2)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis cursos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay cursos registrados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0f04a94","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_cursos_virtuales_lista.vue
// module id = 874
// module chunks = 0